import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_ALL_DISHES } from "../gql/queries";
import AddDishForm from "./AddDishForm";
import SectionHeader from "../../../components/SectionHeader";
import DishPhotoCard from "./DishPhotoCard";
import ImageUploader from "./ImageUploader";

const DishList = () => {

    const [dishes, setDishes] = useState([]);

    const { loading: dishLoading, data: getDishData } = useQuery(GET_ALL_DISHES);
    const dishData = getDishData?.dishes;

    useEffect(() => {
        if (!dishLoading) {
            setDishes(dishData);
        }
    }, [dishData, dishLoading]);

    return (
        <>
            <div className="mainContainer">
                <AddDishForm dishes={dishes} setDishes={setDishes} />
                <SectionHeader title="All Dishes" className='sectionHeader' />
                <div className="allDishesContainer">
                    {dishes && dishes.map((dish) => (
                        <div key={dish._id} className="allDishes">
                            <p id={dish._id}>{dish.dishName}</p>
                            {dish.dishPhoto && <DishPhotoCard image={dish.dishPhoto} dish={dish} style={{ paddingBottom: '15px' }} radius={"15"} border={"3px_solid_rgb:6B802A"} height={"130"} width={"130"} />}
                            {!dish.dishPhoto && <ImageUploader id={dish._id} dish={dish} />}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default DishList;

